export * from "./canvas.types";
export * from "./cell.types";
export * from "./code-editor.types";
export * from "./document.types";
export * from "./editors.types";
export * from "./feature-flags.types";
export * from "./page.types";
export * from "./permission.types";
export * from "./workspace.types";
export * from "./desktop.types";

export type MachineError = {
	message: string;
	context: Record<string, unknown>;
};
